import type { UpdateSaleSchema } from "@/api/schemas/sale.schema";
import { http } from "@/lib/http";
import { useToast } from "@/providers/toast.provider";
import type { SaleWithRelations } from "@/types/sale-with-relations";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useUpdateSale() {
  const queryClient = useQueryClient();
  const { toaster } = useToast();

  return useMutation({
    mutationFn: async ({ id, ...data }: UpdateSaleSchema & { id: string }) => {
      const res = await http.patch<SaleWithRelations>(`/sales/${id}`, data);
      return res.data;
    },

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["sale", "me"] });
    },

    onError: (error) => {
      toaster(error?.message ?? "Algo deu errado!", "error");
    },
  });
}
